import Axios from '../Helpers/axios.js';
import Swal from 'sweetalert2';

export const loginGoogle = async (profileObj) => {
    if(profileObj !== undefined)
    {
        try
        {
            let email = profileObj;
            const data_send = {
                email : email
            };

            const respuesta = await Axios({
                url : 'Login/loginGoogle',
                method : 'POST',
                data : data_send
            })

            const {data} = respuesta;

            if(data.success)
            {
                localStorage.setItem('logueado', 'true');
                localStorage.setItem('usuario', data.data.USERNAME);
                localStorage.setItem('cargo', data.data.CARGO);
                return data;
            }
            else
            {
                Swal.fire('Oops!', data.mensaje, 'error');
                return false;
            }


        }
        catch (e)
        {
            Swal.fire('Oops!', 'Ha ocurrido un problema al intentar indentificarse por favor intentalo otra vez', 'error');
            return false;
        }
    }
    /* else
    {
        if(error !== "popup_closed_by_user")
        {
            Swal.fire('Error', error, 'error');
        }
    } */
};